import { createSelector } from '@reduxjs/toolkit';
import { itemsAdapter } from '@data/slices/itemSlice';
import { RootState } from '@data/store';
import { Item } from '@shared/interfaces';

export const {
  selectAll: selectAllItems,
  selectById,
  selectIds: selectItemIds,
} = itemsAdapter.getSelectors((state: RootState) => state.items);

export const selectItemsState = (state: RootState) => state.items;

export const selectItemsLoading = createSelector(
  [selectItemsState],
  itemsState => itemsState.loading
);

export const selectItemsError = createSelector(
  [selectItemsState],
  itemsState => itemsState.error
);

export const selectItemsIsLoading = createSelector(
  [selectItemsLoading],
  loading => loading === 'loading'
);

export const selectItemById = (itemId?: string) =>
  createSelector(
    [(state: RootState) => state],
    state => (itemId && (selectById(state, itemId) as Item)) || null
  );

export const selectQuery = createSelector(
  [selectItemsState],
  itemsState => itemsState.query || ''
);
